'use client';

import AppLayout from '@/components/AppLayout';
import DailyRecordsContent from './components/DailyRecordsContent';

export default function DailyRecordsPage() {
  return (
    <AppLayout>
      <DailyRecordsContent />
    </AppLayout>
  );
}
